<!-- HEADER -->

<main>
	<slot />
</main>

<!-- FOOTER -->
